/*
 * @Description: 文件下载进度
 * @Date: 2025-07-23 15:37:44
 */
import { route } from './src/router';

const name = 'download-progress';
export { name, route };
